import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const Calendar24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M20 10V8a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V7H8v1a1 1 0 0 1-2 0V7H5a1 1 0 0 0-1 1v2h16Zm0 2H4v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6Zm-2-7h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h1V4a1 1 0 0 1 2 0v1h8V4a1 1 0 0 1 2 0v1Z' /></svg>);
